<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2Yi2ql/images/9781466899612.jpg?1718046090986" alt="This image is the cover for the book Wound and the Bow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wound and the Bow
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Wound and the Bow </i>contains seven essays by "The greatest literary critic of the twentieth century.” -<i>New York</i> magazine.</b><br/><br/>Combining biographical and critical sketches, Edmund Wilson writes brilliantly on a wide-range of authors including Dickens, Kipling, Edith Wharton, Ernest Hemingway, Joyce, Jacques Casanova,  and Sophocles. <br/><br/><b>"In the best tradition of literary criticism… combines exact information with shrewd and searching penetration into the personal life of the artist."-<i>The New York Times</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edmund Wilson
      </h2>
      
      <p class="authorDescription body article"><B>Edmund Wilson</B> (1895-1972) was a novelist, memoirist, playwright, journalist, poet, and editor but it is as a literary critic that he is most highly regarded. His more than twenty books include <I>Axel’s Castle</I>, <I>Patriotic Gor</I>e, <I>To the Finland Station</I>, and <I>Memoirs of Hecate County.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fe6666e